import { render } from "./RecumeView.vue?vue&type=template&id=1489b088&scoped=true"
import script from "./RecumeView.vue?vue&type=script&lang=js"
export * from "./RecumeView.vue?vue&type=script&lang=js"

import "./RecumeView.vue?vue&type=style&index=0&id=1489b088&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1489b088"]])

export default __exports__